/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateUniversalTeamBody
 */
export interface UpdateUniversalTeamBody {
    /**
     * New team name (max 50 chars)
     * @type {string}
     * @memberof UpdateUniversalTeamBody
     */
    name?: string;
    /**
     * New max member count (must be >= current confirmed member count)
     * @type {number}
     * @memberof UpdateUniversalTeamBody
     */
    maxMembers?: number;
}

/**
 * Check if a given object implements the UpdateUniversalTeamBody interface.
 */
export function instanceOfUpdateUniversalTeamBody(value: object): value is UpdateUniversalTeamBody {
    return true;
}

export function UpdateUniversalTeamBodyFromJSON(json: any): UpdateUniversalTeamBody {
    return UpdateUniversalTeamBodyFromJSONTyped(json, false);
}

export function UpdateUniversalTeamBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateUniversalTeamBody {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'maxMembers': json['maxMembers'] == null ? undefined : json['maxMembers'],
    };
}

export function UpdateUniversalTeamBodyToJSON(json: any): UpdateUniversalTeamBody {
    return UpdateUniversalTeamBodyToJSONTyped(json, false);
}

export function UpdateUniversalTeamBodyToJSONTyped(value?: UpdateUniversalTeamBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'maxMembers': value['maxMembers'],
    };
}

